import React from 'react'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import type { IAvatars } from '../Chat.types'

const renderChatHeaderAvatars = (avatars: IAvatars) => {
	if (avatars.length < 3) {
		return avatars.map((avatar, index) => (
			<Avatar key={index}><AvatarImage src={avatar.src} alt={avatar.name} /><AvatarFallback /></Avatar>
		))
	}

	return avatars.map((avatar, index) => {
		if (index === 0) {
			return (
				<Avatar key={index}><AvatarImage src={avatar.src} alt={avatar.name} /><AvatarFallback /></Avatar>
			)
		}
		if (index === 1) {
			return (
				<Avatar key={index} className="bg-[#027fff] text-white">
					<AvatarFallback className="bg-[#027fff] text-white">
						<span style={{ fontSize: `12px`, position: `relative`, left: `4px` }}>{`+${
							avatars.length - 1
						}`}</span>
					</AvatarFallback>
				</Avatar>
			)
		}
		return null
	})
}

export default renderChatHeaderAvatars
